import {
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  CircleSmallLogo,
  HelpIcon,
  ManualsIcon,
  TermsLogo,
  PrivacyLogo,
  SquareLogo,
} from "../assets/Sidebar";
import { useState } from "react";
import { useAppSelector } from "../../../Redux/hooks";

const VersionDetails = () => (
  <Box sx={{ px: 2, pb: 0.5 }}>
    <Typography
      fontWeight={500}
      color="text.primary"
      fontSize={14}
      sx={{ textAlign: "center", mt: 2 }}
    >
      Version 5.0.21 (24/09/2025)
    </Typography>
  </Box>
);

const VersionWrapper = ({ participant }: any) => {
  const collapsed = useAppSelector((state) => state.app.collapsed);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const navigateToLink = (type: string) => {
    setAnchorEl(null);
    if (type === "terms") {
      window.open("https://www.mahalo.health/privacy-policy", "_blank");
    } else {
      window.open("https://mahalo.gitbook.io/mahalo-docs", "_blank");
    }
  };

  return (
    <Box>
      <Divider sx={{ borderColor: "#374151" }} />
      <Box className="sider-menu" onClick={openMenu}>
        <HelpIcon />
        {!collapsed && (
          <Typography variant="subtitle1" ml={0.5}>
            Help
          </Typography>
        )}
      </Box>
      {!collapsed && (
        <>
          <Divider sx={{ borderColor: "#374151" }} />
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              my: 2,
              ml: 1,
            }}
          >
            {participant ? <CircleSmallLogo /> : <SquareLogo />}
            <Typography variant="body2" fontWeight={"medium"} color="#FFF">
              Powered by Mahalo
            </Typography>
          </Box>
        </>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            mt: -1.5,
          },
        }}
      >
        <MenuItem onClick={() => navigateToLink("terms")}>
          <ListItemIcon>
            <PrivacyLogo />
          </ListItemIcon>
          <Typography
            sx={{ color: "text.primary", fontWeight: "500", fontSize: "14px" }}
          >
            Privacy Policy
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => navigateToLink("terms")}>
          <ListItemIcon>
            <TermsLogo />
          </ListItemIcon>
          <Typography
            sx={{ color: "text.primary", fontWeight: "500", fontSize: "14px" }}
          >
            Terms of Use
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => navigateToLink("manuals")}>
          <ListItemIcon>
            <ManualsIcon />
          </ListItemIcon>
          <Typography
            sx={{ color: "text.primary", fontWeight: "500", fontSize: "14px" }}
          >
            Manuals
          </Typography>
        </MenuItem>
        <Divider />
        <VersionDetails />
      </Menu>
    </Box>
  );
};

export default VersionWrapper;
